<template>
    <div>
        <top></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
            <!-- <div class="company_wp">
                <div class="company_img">
                    <img src="../../images/tx.jpg" alt="" />
                </div>
                <div class="comoany_text">
                    <div class="my-title">
                        公司介绍
                    </div>
                    <div class="my_text">
                        上海康买医疗科技有限公司成立于2010年，前身是奥林巴斯创达贸易（上海）有限公司。是日本Olympus
                        Business Creation
                        Company(OBCC)株式会社的上海全资子公司。公司于2014年被日本フイ一ド株式会社全资收购，名称变更为上海康买贸易有限公司。鉴于康买在国内牙科目录销售已大获成功，2015年7月康买被国内知名企业全资收购，公司名称变更为：上海康买医疗科技有限公司。
                    </div>
                    <div class="my_text">
                        康买成立之初借鉴在日本的成功经验，于2010年推出牙科目录试刊号，截止目前已推出6期牙科产品目录，开创了国内牙科产品目录一站式采购的先河；让目录销售这一全新的牙科产品订购方式，快速为牙科医生所熟知，仅仅长三角地区就有上万家的忠实客户。
                    </div>
                    <div class="my_text">
                        不仅如此在网络浏览等线上领域，康买也走在了牙科行业大多数同行的前列，目前康买官方商城及微信商城的影响力正逐步扩大。康买坚持无假货、重质量、守信誉、售前便捷、售后贴心的服务准则不断影响着牙科行业。
                    </div>
                    <div class="my_text">
                        在牙科材料采购方面，不管您有任何问题，我们都愿意成为您最忠实的伙伴
                    </div>
                </div>
            </div> -->
            <div v-html="content">

            </div>

            <!-- <div class="company_cert">
             <div class="_cert">
                  <img src="../../images/tx.jpg" alt="">
             </div>
               <div class="_cert">
                  <img src="../../images/tx.jpg" alt="">
             </div>
               <div class="_cert">
                  <img src="../../images/tx.jpg" alt="">
             </div>

            </div> -->
        </div>

        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import { indexRichtext } from "@/api/index.js";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        return {
            url: [{ name: "公司介绍", url: "/company" }],
            content:''
        };
    },
    components: {
        top,
        breadcrumb,
        bottom
    },
    created(){
    this.getSoureceVender()
    },
    methods:{
        getSoureceVender(){
        indexRichtext({id:13}).then(res=>{
        console.log(res);
        this.content = res.data.content
        })
        }

    },


};
</script>
<style lang="less" scoped>
.company_wp {
    display: flex;
    .my-title {
        font-size: 20px;
        padding: 0 10px;
        border-left: 5px solid #ff6701;
        margin-bottom: 10px;
        margin-left: -10px;
        line-height: 40px;
        font-weight: 400;
    }
    .comoany_text {
        margin-left: 30px;
        margin-bottom:30px;
        .my_text {
            width: 702px;
            margin-bottom: 20px;
            text-indent: 20px;
            font-size: 16px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #666666;
            line-height: 24px;
        }
    }
    margin-top: 44px;
    .company_img {
        width: 391px;
        height: 269px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
.company_cert{
flex-wrap: wrap;
display: flex;
._cert{
width: 318px;
    height: 240px;
    margin-right: 82px;
    margin-bottom: 20px;
img{
    width: 100%;
    height: 100%;
}
}

}
</style>



// WEBPACK FOOTER //
// src/views/index/company.vue